import * as _accessors from './accessors';
import * as _actions from './actions';
import _reducer from './reducer';

export const accessors = _accessors;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/GroupLessonAwards/index.js